import type { ComponentProps } from "react";
import { LinearGradient } from "@tamagui/linear-gradient";
import { getTokenValue, ResponsiveImage, YStack } from "@medbillai/ui";
import { withAlpha } from "@medbillai/utils/color";

// Native fades "transparent" through black (rgba(0,0,0,0)); resolve $surface1
// at zero alpha so the edges fade through the screen color instead.
const surface1 = String(getTokenValue("$surface1", "color"));
const surface1Transparent = withAlpha(surface1, 0);

// How far each edge fades in, as a fraction of the wall width — enough to cover
// the partial logos the asset crops at its left/right edges.
const FADE_WIDTH = "16%";
type LogoWallProps = Pick<ComponentProps<typeof ResponsiveImage>, "src" | "alt" | "testID">;
export function LogoWall({
  src,
  alt,
  testID
}: LogoWallProps) {
  return <YStack flex={1} justifyContent="center" position="relative" data-sentry-element="YStack" data-sentry-component="LogoWall" data-sentry-source-file="LogoWall.tsx">
      <ResponsiveImage testID={testID} src={src} alt={alt} objectFit="contain" width="100%" data-sentry-element="ResponsiveImage" data-sentry-source-file="LogoWall.tsx" />
      <LinearGradient position="absolute" left={0} top={0} bottom={0} width={FADE_WIDTH} zIndex={1} start={{
      x: 0,
      y: 0
    }} end={{
      x: 1,
      y: 0
    }} colors={[surface1, surface1Transparent]} pointerEvents="none" data-sentry-element="LinearGradient" data-sentry-source-file="LogoWall.tsx" />
      <LinearGradient position="absolute" right={0} top={0} bottom={0} width={FADE_WIDTH} zIndex={1} start={{
      x: 0,
      y: 0
    }} end={{
      x: 1,
      y: 0
    }} colors={[surface1Transparent, surface1]} pointerEvents="none" data-sentry-element="LinearGradient" data-sentry-source-file="LogoWall.tsx" />
    </YStack>;
}